"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dict = require("@ys/utils/lib/dict");
var _constants = require("./constants");
var _default = exports.default = {
  name: 'YsAsyncImport',
  inject: {
    ysProviderContext: {
      default: () => ({
        api: {}
      })
    }
  },
  props: {
    title: {
      type: String,
      default: '导入'
    },
    bizType: {
      type: String,
      required: true
    },
    accept: {
      type: String,
      default: '.xls,.xlsx'
    },
    maxCount: {
      type: Number,
      default: 1
    },
    uploadMethod: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      columns: [{
        title: '序号',
        dataIndex: 'index',
        width: 80,
        customRender: (text, record, index) => index + 1
      }, {
        title: '文件名称',
        dataIndex: 'fileName',
        width: 200
      }, {
        title: '导入时间',
        dataIndex: 'createTime',
        width: 180
      }, {
        title: '操作人',
        dataIndex: 'createUserName',
        width: 120
      }, {
        title: '处理状态',
        dataIndex: 'status',
        customRender: text => (0, _dict.translate)(text, _constants.IMPORT_STATUS),
        width: 120
      }, {
        title: '导入进度',
        dataIndex: 'processValue',
        width: 120
      }],
      importVisible: false,
      fileList: []
    };
  },
  methods: {
    getFileJobList(page) {
      return this.ysProviderContext.api?.getFileJobList({
        ...page,
        bizType: this.bizType
      });
    },
    beforeUpload(file) {
      this.fileList.splice(0, this.fileList.length, file);
      return false;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      this.fileList.splice(index, 1);
    },
    async handleConfirm() {
      if (!this.fileList.length) {
        this.$message.warn('请上传文件');
        return;
      }
      this.uploadMethod(this.fileList);
      this.$message.success('文件导入中');
      this.fileList = [];
      this.importVisible = false;
      this.$refs.jobListRef.reload();
      this.$emit('submit');
    },
    handleImportCancel() {
      this.fileList = [];
      this.$emit('import-cancel');
    }
  }
};